import { gql } from '__generated__';

export default gql(`
  query GetOrderFilters($project_id: ID!, $events: [ID!]) {
    project(id: $project_id) {
      id
      mail_permissions {
        id
        title
        integration {
          id
        }
      }
      events(ids: $events) {
        data {
          id
          title
          end_date
          ticket_categories {
            id
            title
            tickets {
              id
              title
              promotions {
                id
                title
              }
              time_slots {
                id
                start_date
                start_time
                title
                multi_date
              }
            }
          }
          products {
            id
            title
            promotions {
              id
              title
            }
            product_variants {
              id
              title
            }
          }
          invitations {
            id
            has_unique_codes
            prefix
          }
          discounts {
            id
            title
          }
          coupons {
            id
            prefix
          }
          lotteries {
            id
            title
          }
          participant_fields {
            id
            title
            scope
            type
            enabled
            choices {
              id
              title
              enabled
            }
            tickets {
              id
            }
            products {
              id
            }
          }
        }
        current_page
        last_page
        per_page
        total
      }
    }
  }
`);
